<template>
  <modal-padrao
    ref="modal-mensagem"
    :titulo="$t('modulos.orcamentos.formulario.mensagem')"
    max-width="80%"
    :titulo-ok="$t('geral.botoes.confirmar')"
    @ok="salvar"
  >
    <tabela-padrao-prime-vue
      ref="tabela"
      v-model="selecionados"
      :dados="tabela.dados"
      filtros-com-colunas
      class="mt-6"
      filtro-global-focus
      :colunas="tabela.colunas"
      :por-pagina="tabela.porPagina"
      :quantidade-itens="tabela.quantidadeItens"
      :quantidade-paginas="tabela.quantidadePaginas"
      :mostrar-seletor="true"
      :mostrar-acoes="false"
      @paginar="listar"
      @filtrarGlobal="listar"
      @filtroGlobal="(v) => (filtroAplicado.filter = v)"
      @fechar-modal-click-linha="() => $emit('fechar-modal-click-linha')"
    >
      <template v-slot:descricao="{ slotProps }">
        <div class="formatar-mensagem">
          <span>{{ slotProps.data.descricao }}</span>
        </div>
      </template>
    </tabela-padrao-prime-vue>
  </modal-padrao>
</template>
<script>
import MensagemOrcamentoService from '@common/services/cadastros/MensagemOrcamentoService';
import helpers from '@/common/utils/helpers';
import _ from 'lodash';
export default {
  props: {
    form: {},
    dados: {},
    mensagensSelecionadas: { type: Array, default: () => [] },
  },
  data() {
    return {
      keyAtualiza: 1,
      expanded: [],
      dadosOverlayPanel: [],
      singleExpand: false,
      filtro: {},
      filtroAplicado: { filter: '' },
      selecionados: [],
      tabela: {
        dados: [],
        colunas: [
          {
            value: 'titulo',
            text: this.$t('modulos.mensagem_orcamento.tabela.nome'),
            sortable: true,
          },
          {
            value: 'descricaoClassificacao',
            text: this.$t('modulos.mensagem_orcamento.tabela.classificacao'),
            sortable: true,
          },
          {
            value: 'descricao',
            text: this.$t('modulos.mensagem_orcamento.tabela.descricao'),
          },
        ],
        quantidadeItens: 0,
        quantidadePaginas: 0,
        paginaAtual: 1,
        porPagina: 10,
      },
    };
  },
  methods: {
    abrirModal() {
      this.keyAtualiza++;
      this.$refs['modal-mensagem'].abrirModal();
      this.listar(this.tabela.paginaAtual);
    },
    filtrar: function () {
      this.filtroAplicado = _.cloneDeep(this.filtro);
      this.listar(this.tabela.paginaAtual);
    },
    listar: async function (paginaAtual = 1, porPagina = 10) {
      this.selecionados = [];
      let mensagensIgnoradas = this.mensagensSelecionadas.map(
        (mensagem) => mensagem.id
      );

      let parametros = {
        page: paginaAtual,
        amountPerPage: porPagina,
        ...helpers.formattingParameters(this.filtroAplicado),
        MensagensIgnoradas: mensagensIgnoradas,
      };

      this.$store.dispatch('Layout/iniciarCarregamento');
      MensagemOrcamentoService.listar(parametros)
        .then((res) => {
          this.tabela.dados = res.data.items;
          this.tabela.quantidadeItens = res.data.totalItems;
          this.tabela.quantidadePaginas = res.data.totalPages;
          this.tabela.paginaAtual = paginaAtual;
          this.tabela.porPagina = porPagina;
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    salvar: function () {
      this.$emit('novaMensagem', this.selecionados);
      this.$refs['modal-mensagem'].fecharModal();
    },
    selecionarTabela: function (item, selecionado) {
      if (!selecionado) {
        this.selecionados.splice(
          this.selecionados.indexOf(
            this.selecionados.find((el) => el.id == item.id)
          ),
          1
        );
      } else {
        this.selecionados.push(item);
      }
    },
  },
};
</script>
